import { Field, RichText, Text, useSitecoreContext } from '@sitecore-jss/sitecore-jss-nextjs';

import { ComponentProps, SitecoreContextValue } from 'src/lib/ComponentProps';

import IsSitecoreEditing from 'src/utils/isSitecoreEditing';

import styles from './CourseOverviewModeOfDelivery.module.css';

type CourseOverviewModeOfDeliveryProps = ComponentProps & {
	fields: {
		ModeOfDelivery: Field<string>;
	};
};

export default function CourseOverviewModeOfDelivery(props: CourseOverviewModeOfDeliveryProps): JSX.Element {
	const { sitecoreContext } = useSitecoreContext<SitecoreContextValue>();
	const isEditing = IsSitecoreEditing();

	if (!isEditing && !props.fields?.ModeOfDelivery?.value) {
		return <></>;
	}

	return (
		<div className={styles.overviewModeOfDeliveryContainer}>
			<Text tag="h1" field={{ value: sitecoreContext.dictionary.modeOfDelivery }} className={styles.overviewModeOfDeliveryHeader}></Text>
			<RichText field={props.fields?.ModeOfDelivery} className={styles.overviewModeOfDeliveryText} />
		</div>
	);
}
